import type {
  ScheduledPostResponse,
  UpdateScheduledPostBody,
} from "@nlc/shared-types";
import type { UseMutationResult } from "@tanstack/react-query";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { socialPublishingKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

interface UpdateScheduledPostVariables {
  body: UpdateScheduledPostBody;
  id: number;
}

async function updateScheduledPost({
  body,
  id,
}: UpdateScheduledPostVariables): Promise<ScheduledPostResponse> {
  return apiClient
    .url(`/social-publishing/scheduled-posts/${id}`)
    .patch(body)
    .json();
}

export function useUpdateScheduledPost(): UseMutationResult<
  ScheduledPostResponse,
  { message?: string },
  UpdateScheduledPostVariables
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateScheduledPost,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: socialPublishingKeys.scheduledPosts(),
      });
    },
  });
}
